import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Start a Stripe checkout for a server-defined product (by lookup_key). */
export async function startStripeCheckout(lookupKey, userId) {
  try {
    const { data } = await axios.post(`${API}/payments/checkout`, {
      lookup_key: lookupKey,
      origin_url: window.location.origin,
      user_id: userId || null,
    });
    if (data.checkout_url) {
      window.location.href = data.checkout_url;
    } else {
      toast.error("Could not start checkout.");
    }
  } catch (err) {
    toast.error(err.response?.data?.detail || "Checkout failed. Please try again.");
  }
}
